import React, { useEffect, useState } from "react";
import { fetchReportShelterIntakesExits } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterIntake7DayMetricState {
  data?: any[];
  setSelectedData: (data: any[] | null) => void;
  active: boolean;
  setActive: (active: boolean) => void;
}

export const ShelterIntake7DayMetric = ({ data, setSelectedData, active, setActive }: ShelterIntake7DayMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();
  const [readOnly, setReadOnly] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        const recentIntakes = data.filter((item: any) => isWithinLast7Days(item.intake_at));
        const recentIntakesCount = recentIntakes.length.toString();
        setCurrent(recentIntakesCount);
        setCurrentData(recentIntakes);
        setReadOnly(false);
        setIsLoading(false);
      } else {
        await getIntakesData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getIntakesData = async () => {
    await fetchReportShelterIntakesExits()
      .then((res: any) => {
        const data = res[0].data;
        const recentIntakes = data.filter((item: any) => isWithinLast7Days(item.intake_at));
        const recentIntakesCount = recentIntakes.length.toString();
        setCurrent(recentIntakesCount);
        setCurrentData(recentIntakes);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  function isWithinLast7Days(dateStr: string) {
    const today = new Date();
    const intakeDate = new Date(dateStr);

    today.setHours(0, 0, 0, 0);
    intakeDate.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - intakeDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= 8; // 7 days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }

    setActive(!active);
  };

  if (readOnly) {
    return <SingleCardMetric title={"Intakes Last 7 Days"} total={current} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Intakes Last 7 Days"}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
